import { railColor } from "@/lib/tokens";
import styles from "./ui.module.css";

export function StatusRail({
  state,
  pulse = false,
}: {
  state: string;
  pulse?: boolean;
}) {
  return (
    <span
      className={[styles.rail, pulse ? styles.pulse : ""].filter(Boolean).join(" ")}
      style={{ background: railColor(state) }}
      aria-hidden
    />
  );
}
